<template>
  <!--==================
    component for reset new user password
    ===============-->
  <div class="container-login100">
    <div class="wrap-login">
      <div class="wrap-login100">
        <div v-if="errorMessage" class="text-center text-danger mb-5 col">
          <em class="text-capitalize">{{ errorMessage }}</em>
        </div>
        <div v-if="successMessage" class="text-center text-success mb-5 col">
          <em>Password changed successfull!</em>
        </div>

        <form @submit.prevent="submitFormData" class="login100-form validate-form">
          <div class="login100-form-logo">
            <img src="@/assets/images/logo.png" />
          </div>

          <div class="wrap-input100 validate-input">
            <input
              class="input100"
              type="password"
              placeholder="password"
              :disabled="submitForm"
              v-model="form.pass1"
              @input="$v.form.pass1.$touch()"
            />
            <i class="zmdi zmdi-lock focus-input"></i>
            <span class="text-danger" v-if="$v.form.pass1.$dirty && $v.form.pass1.$invalid">
              &nbsp; Password is too weak
            </span>
          </div>

          <div class="wrap-input100 validate-input">
            <input
              class="input100"
              type="password"
              placeholder="confirm password"
              :disabled="submitForm"
              v-model="form.pass2"
              @input="$v.form.pass2.$touch()"
            />
            <i class="zmdi zmdi-lock focus-input"></i>
            <span class="text-danger" v-if="$v.form.pass2.$dirty && $v.form.pass2.$invalid">
              &nbsp; Password not match
            </span>
          </div>

          <div class="container-login100-form-btn">
            <button class="login100-form-btn" :disabled="$v.form.$invalid">
              <span v-if="!submitForm">Submit</span>
              <span v-if="submitForm" class="spinner-border spinner-border-sm" role="status"></span>
              <span v-if="submitForm" class="ml-2">Submitting...</span>
            </button>
          </div>
        </form>
      </div>
      <p>
        &copy; {{ footerYear }} Safari-Tz | By
        <a class="txt1" href="http://www.isaxstar.co.tz" target="_blank">Isaxstar Developer</a>
      </p>
    </div>
  </div>
</template>

<style scoped>
@import "@/assets/vendor/login-v3/fonts/iconic/css/material-design-iconic-font.min.css";
@import "@/assets/vendor/login-v3/css/util.css";
@import "@/assets/vendor/login-v3/css/main.css";
</style>

<script>
import $ from "jquery";
import axios from "axios";
import { required, sameAs, minLength } from "vuelidate/lib/validators";
import { passRegex } from "@/validator";

export default {
  name: "ResetPassword",

  data() {
    return {
      footerYear: null,
      form: {},
      submitForm: false,
      errorMessage: false,
      successMessage: false,
    };
  },

  mounted() {
    document.title = "Reset Password";
    this.getFooterYear();
    this.focusInput();
    this.form.email = new URL(location.href).searchParams.get("email");
    this.form.token = new URL(location.href).searchParams.get("key");
  },

  validations() {
    return {
      form: {
        pass1: { required, passRegex, minLength: minLength(8) },
        pass2: {
          required,
          sameAsPassword: sameAs("pass1"),
        },
      },
    };
  },

  methods: {
    getFooterYear() {
      var now = new Date();
      this.footerYear = now.format("yyyy");
    },

    submitFormData() {
      this.$v.form.$reset();
      this.submitForm = true;
      this.errorMessage = false;

      const url = process.env.VUE_APP_API_URL;

      const data = {
        username: this.form.email,
        token: this.form.token,
        password: this.form.pass1,
      };

      axios.post(`${url}/auth/reset-password`, data).then((res) => {
        if (res.data.statusCode === 406) {
          this.submitForm = false;
          this.errorMessage = res.data.message;
          this.form = {};
        } else {
          this.submitForm = false;
          this.successMessage = true;
          this.form = {};

          setTimeout(() => {
            window.location.href = "/";
          }, 3000);
        }
      });
    },

    focusInput() {
      $(".input100").each(function () {
        $(this).on("blur", function () {
          if ($(this).val().trim() != "") {
            $(this).addClass("has-val");
          } else {
            $(this).removeClass("has-val");
          }
        });
      });
    },
  },
};
</script>
